import { Diagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/Diagram';
import { DiagramBox } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramBox';
import { DiagramText } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramText';
import { BoxTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/BoxTone';
import { TextTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/TextTone';

export const RankingShareOfWalletDiagram = () => (
  <Diagram viewBox="0 0 300 105">
    <DiagramBox x={8} y={22} width={86} height={30} tone={BoxTone.YES} />
    <DiagramText x={51} y={41} bold>
      A · 0% TIN
    </DiagramText>
    <DiagramBox x={106} y={22} width={86} height={30} tone={BoxTone.YES} />
    <DiagramText x={149} y={41} bold>
      B · 0% TIN
    </DiagramText>
    <DiagramBox x={204} y={22} width={86} height={30} tone={BoxTone.GHOST} />
    <DiagramText x={247} y={41} tone={TextTone.GHOST}>
      C · 7,9% TIN
    </DiagramText>
    <DiagramText x={51} y={70} tone={TextTone.MUTED} small tId="COSTS_YOU">
      {'3% · '}
    </DiagramText>
    <DiagramText x={149} y={70} tone={TextTone.MUTED} small tId="COSTS_YOU">
      {'5% · '}
    </DiagramText>
    <DiagramText x={51} y={94} bold tone={TextTone.YES}>
      1º
    </DiagramText>
    <DiagramText x={149} y={94} bold>
      2º
    </DiagramText>
    <DiagramText x={247} y={94} tone={TextTone.GHOST}>
      3º
    </DiagramText>
  </Diagram>
);
